import ky from 'ky'

import { API_PREFIX } from '../config'
import { getSessionState } from './sessionStore'

export const logEvents = async (data: Record<string, unknown>) => {
  // Only send telemetry in production builds; skip in dev/test to avoid noisy logs and test warnings
  if (!import.meta.env.PROD) return

  const { organizationUid, sessionUid } = getSessionState()

  try {
    await ky.post(`${API_PREFIX}/hedwig/treat`, {
      json: [
        {
          organizationUid,
          sessionUid,
          ts: Date.now(),
          data,
        },
      ],
    })
  } catch (error) {
    // oxlint-disable-next-line no-console -- intentionally swallow telemetry errors
    console.log(error)
  }
}
